// extracted by mini-css-extract-plugin
module.exports = {"container":"Registration_container__UUyfR","sectionHeading":"Registration_sectionHeading__iducx","fieldHeading":"Registration_fieldHeading__pafW5"};